import type { PeopleRefinerSelection } from "../store/schema/PeopleRefinerSelection";
import getStore from "../store/store";

export default function getFromRefinerSelections(): PeopleRefinerSelection[] {
    return getStore().fromRefinerSelections;
}
